// extracted by mini-css-extract-plugin
export default {"closeIcon":"dialog_closeIcon__abhef"};